import httpClient from "../httpClient";

export const patchDs82BotStatusPause = ({ manualPause }) =>
  httpClient.patch("/ds82/bot-status/pause", { manualPause });
